import React, { useState } from 'react';
import { Box, Select, MenuItem, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckIcon from '@mui/icons-material/Check';

const FormatingTypeSelector = () => {
    const [postType, setPostType] = useState('All Formating');

    const handleChange = (event) => {
        setPostType(event.target.value);
    };

    const menuItems = [
      
        "All Formating"
    ];

    return (
        <Box>
            <Select
                value={postType}
                onChange={handleChange}
                IconComponent={KeyboardArrowDownIcon}
                renderValue={(value) => value} // This ensures only the text shows in the input
                sx={{
                    width: '100%',
                    height: '40px',
                    backgroundColor: 'white',
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white'
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white'
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'white'
                    },
                    '& .MuiSelect-select': {
                        paddingY: '8px',
                    }
                }}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            backgroundColor: '#f5f5f5',
                            '& .MuiMenuItem-root': {
                                padding: '8px 16px',
                                fontSize: '14px',
                                '&.Mui-selected': {
                                    backgroundColor: '#f5f5f5',
                                    '&:hover': {
                                        backgroundColor: '#1976d2',
                                    }
                                },
                                '&:hover': {
                                    backgroundColor: '#1976d2',
                                    color: 'white',

                                }
                            }
                        }
                    }
                }}
            >
                {menuItems.map((item) => (
                    <MenuItem key={item} value={item}>
                        <Box sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            marginLeft:'15px',
                        }}>
                            {postType === item && (
                                <CheckIcon sx={{ fontSize: 16,fontWeight:'bold' ,marginLeft:'-15px'}} />
                            )}
                            {item}
                        </Box>
                    </MenuItem>
                ))}
            </Select>
        </Box>
    );
};

export default FormatingTypeSelector;